/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_IdInputs */

const en_listing_id = /** @type {(inputs: Listing_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing ID:`)
};

const es_listing_id = /** @type {(inputs: Listing_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID del anuncio:`)
};

const fr_listing_id = /** @type {(inputs: Listing_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de l'annonce :`)
};

const de_listing_id = /** @type {(inputs: Listing_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserat-ID:`)
};

const ja_listing_id = /** @type {(inputs: Listing_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品ID:`)
};

const zh_listing_id = /** @type {(inputs: Listing_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品 ID：`)
};

const ar_listing_id = /** @type {(inputs: Listing_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معرف الإعلان:`)
};

const id_listing_id = /** @type {(inputs: Listing_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Listing:`)
};

const it_listing_id = /** @type {(inputs: Listing_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Annuncio:`)
};

const ru_listing_id = /** @type {(inputs: Listing_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID объявления:`)
};

const pt_listing_id = /** @type {(inputs: Listing_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID do Anúncio:`)
};

const ko_listing_id = /** @type {(inputs: Listing_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 ID:`)
};

/**
* | output |
* | --- |
* | "Listing ID:" |
*
* @param {Listing_IdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_id = /** @type {((inputs?: Listing_IdInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_IdInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_id(inputs)
	if (locale === "es") return es_listing_id(inputs)
	if (locale === "fr") return fr_listing_id(inputs)
	if (locale === "de") return de_listing_id(inputs)
	if (locale === "ja") return ja_listing_id(inputs)
	if (locale === "zh") return zh_listing_id(inputs)
	if (locale === "ar") return ar_listing_id(inputs)
	if (locale === "id") return id_listing_id(inputs)
	if (locale === "it") return it_listing_id(inputs)
	if (locale === "ru") return ru_listing_id(inputs)
	if (locale === "pt") return pt_listing_id(inputs)
	return ko_listing_id(inputs)
});